import IEntity from "./Entity";

export default interface IBankBillet extends IEntity {
	_id?: string;
	zoopId?: string;
	referenceNumber?: string;
	barCode?: string;
	url?: string;
	value?: string | any;
	dueDate?: string;
	description?: string;
	document?: string;
	name?: string;
	email?: string;
	street?: string;
	number?: string;
	complement?: string;
	neighborhood?: string;
	city?: string;
	state?: string;
	country?: string;
	zipCode?: string;
	user?: string;
	status?: BankBilletStatus | any;
}

export enum BankBilletStatus {
	pending = 0,
	paid = 1,
	failed = 2,
	canceled = 3,
	notPaid = 4
}
